import { lazy } from "react";

const route = (path, loader) => ({
  path,
  component: lazy(loader),
});

export const reOrganizationRoutes = [
  route(
    "/psenrollform",
    () => import("../../SvamitvaServices/EnrolmentOfPS/PSEnrollmentForm")
  ),

  route(
    "/psenrollreport",
    () =>
      import(
        "../../SvamitvaServices/EnrolmentOfPS/ReOrganisationMPDOStatusReport"
      )
  ),

  route(
    "/enrollmentabstract",
    () =>
      import("../../SvamitvaServices/EnrolmentOfPS/EnrollmentAbstract")
  ),

  route(
    "/addEmployees",
    () => import("../../SvamitvaServices/EnrolmentOfPS/AddEmployees")
  ),

  route(
    "/addEmployeesreport",
    () => import("../../SvamitvaServices/EnrolmentOfPS/AddEmpsReport")
  ),

  route(
    "/esigncompletedresponse/:transId/:scode",
    () =>
      import("../../SvamitvaServices/EnrolmentOfPS/EsignCompletedResponse")
  ),

  route(
    "/seniorityList",
    () => import("../../SvamitvaServices/EnrolmentOfPS/SeniorityList")
  ),

  route(
    "/confirmationscreen",
    () =>
      import("../../SvamitvaServices/EnrolmentOfPS/ConfirmationScreen")
  ),

  route(
    "/sourcescreen",
    () => import("../../SvamitvaServices/EnrolmentOfPS/SourceScreen")
  ),

  route(
    "/cprsourcescreenreport",
    () =>
      import("../../SvamitvaServices/EnrolmentOfPS/CprSourceScreenReport")
  ),

  route(
    "/revertpublish",
    () => import("../../SvamitvaServices/EnrolmentOfPS/RevertPublish")
  ),

  route(
    "/nocscreen",
    () => import("../../SvamitvaServices/EnrolmentOfPS/Noc")
  ),

  route(
    "/objectionscreen",
    () => import("../../SvamitvaServices/EnrolmentOfPS/ObjectionScreen")
  ),

  route(
    "/seniorityListPreparationStatusReport",
    () =>
      import(
        "../../SvamitvaServices/EnrolmentOfPS/SeniorityListPrepStatusReport"
      )
  ),
];